import http from "../http";

const apiUrl = `${process.env.REACT_APP_API_URL}hajj-packages`;

export function getHajjPackages(params) {
  return http.get(apiUrl, { params });
}

export function getHajjPackage(id) {
  return http.get(`${apiUrl}/${id}`);
}

export function getProfitLossSummary(params) {
  return http.get(`${apiUrl}/profit-loss`, { params });
}

export function saveHajjPackage(data) {
  if (data.id) return http.patch(`${apiUrl}/${data.id}`, data);
  return http.post(apiUrl, data);
}

export function deleteHajjPackage(id) {
  return http.delete(`${apiUrl}/${id}`);
}
